import {
  ContactFormActionsContext,
  ContactFormDataContext,
  useContactFormActionsFromContext,
  useContactFormDataFromContext,
} from 'src/SharedCommonContext/ContactFormContext';
import { Heading } from 'src/components/Form';
import Row from 'src/components/Row';
import { ServiceType } from 'src/components/ContactForm/types';
import Col from 'src/components/Col';
import Tile from 'src/components/Tile';
import FontAwesomeIcon from 'src/components/Icon';
import { ICONS } from 'src/common/constants';
import React from 'react';

const ServiceTypeSelector = ({ types }: any) => {
  const { contactFormData }: ContactFormDataContext =
    useContactFormDataFromContext();

  const { setContactFormData }: ContactFormActionsContext =
    useContactFormActionsFromContext();

  if (
    contactFormData.userRole !== 'Service Provider' &&
    contactFormData.userRole !== 'Vendor'
  ) {
    return null;
  }

  return (
    <>
      <Heading>
        Service Provided <span style={{ color: 'red' }}>*</span>
        <div
          style={{
            paddingTop: '1rem',
            color: '#454F5B',
            fontWeight: '620',
          }}
        >
          Please select all that apply
        </div>
      </Heading>
      <Row granola>
        {types.map((issueType: ServiceType, i: number) => (
          <Col granola key={i} md="4" xs="6">
            <Tile
              icon={
                <FontAwesomeIcon weight="light" glyph={ICONS[issueType.name]} />
              }
              active={
                contactFormData.servicesProvided?.includes(issueType.name) ??
                false
              }
              onClick={() => {
                const currentServices = contactFormData.servicesProvided ?? [];
                const newServices = currentServices.includes(issueType.name)
                  ? currentServices.filter((i: string) => i !== issueType.name)
                  : [...currentServices, issueType.name];
                setContactFormData({ servicesProvided: newServices });
              }}
              title={
                issueType.name === 'Heating/Cooling'
                  ? `${issueType.name.substring(
                      0,
                      issueType.name.lastIndexOf('/')
                    )} / ${issueType.name.substring(
                      issueType.name.lastIndexOf('/') + 1,
                      issueType.name.length
                    )}`
                  : issueType.name
              }
              size="tiny"
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ServiceTypeSelector;
